import { useFeatureAvailable, useSoftDeployAccess } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function ListPeriodizationsAllowed() {
	const hasReactPage = useSoftDeployAccess('REACT_PERIODIZATIONS_PAGE');
	const hasFeature = useFeatureAvailable(Feature.PERIODIZATION);
	return hasReactPage && hasFeature;
}
